__turbopack_context__.v({
  "content-container": "uynhga_content-container",
  "padding-bottom-desktop-3xl": "uynhga_padding-bottom-desktop-3xl",
  "padding-bottom-desktop-3xs": "uynhga_padding-bottom-desktop-3xs",
  "padding-bottom-desktop-l": "uynhga_padding-bottom-desktop-l",
  "padding-bottom-desktop-m": "uynhga_padding-bottom-desktop-m",
  "padding-bottom-desktop-none": "uynhga_padding-bottom-desktop-none",
  "padding-bottom-desktop-s": "uynhga_padding-bottom-desktop-s",
  "padding-bottom-desktop-xl": "uynhga_padding-bottom-desktop-xl",
  "padding-bottom-desktop-xs": "uynhga_padding-bottom-desktop-xs",
  "padding-bottom-desktop-xxl": "uynhga_padding-bottom-desktop-xxl",
  "padding-bottom-desktop-xxs": "uynhga_padding-bottom-desktop-xxs",
  "padding-bottom-mobile-3xl": "uynhga_padding-bottom-mobile-3xl",
  "padding-bottom-mobile-3xs": "uynhga_padding-bottom-mobile-3xs",
  "padding-bottom-mobile-l": "uynhga_padding-bottom-mobile-l",
  "padding-bottom-mobile-m": "uynhga_padding-bottom-mobile-m",
  "padding-bottom-mobile-none": "uynhga_padding-bottom-mobile-none",
  "padding-bottom-mobile-s": "uynhga_padding-bottom-mobile-s",
  "padding-bottom-mobile-xl": "uynhga_padding-bottom-mobile-xl",
  "padding-bottom-mobile-xs": "uynhga_padding-bottom-mobile-xs",
  "padding-bottom-mobile-xxl": "uynhga_padding-bottom-mobile-xxl",
  "padding-bottom-mobile-xxs": "uynhga_padding-bottom-mobile-xxs",
  "padding-top-desktop-3xl": "uynhga_padding-top-desktop-3xl",
  "padding-top-desktop-3xs": "uynhga_padding-top-desktop-3xs",
  "padding-top-desktop-l": "uynhga_padding-top-desktop-l",
  "padding-top-desktop-m": "uynhga_padding-top-desktop-m",
  "padding-top-desktop-none": "uynhga_padding-top-desktop-none",
  "padding-top-desktop-s": "uynhga_padding-top-desktop-s",
  "padding-top-desktop-xl": "uynhga_padding-top-desktop-xl",
  "padding-top-desktop-xs": "uynhga_padding-top-desktop-xs",
  "padding-top-desktop-xxl": "uynhga_padding-top-desktop-xxl",
  "padding-top-desktop-xxs": "uynhga_padding-top-desktop-xxs",
  "padding-top-mobile-3xl": "uynhga_padding-top-mobile-3xl",
  "padding-top-mobile-3xs": "uynhga_padding-top-mobile-3xs",
  "padding-top-mobile-l": "uynhga_padding-top-mobile-l",
  "padding-top-mobile-m": "uynhga_padding-top-mobile-m",
  "padding-top-mobile-none": "uynhga_padding-top-mobile-none",
  "padding-top-mobile-s": "uynhga_padding-top-mobile-s",
  "padding-top-mobile-xl": "uynhga_padding-top-mobile-xl",
  "padding-top-mobile-xs": "uynhga_padding-top-mobile-xs",
  "padding-top-mobile-xxl": "uynhga_padding-top-mobile-xxl",
  "padding-top-mobile-xxs": "uynhga_padding-top-mobile-xxs",
  "placeholder": "uynhga_placeholder",
  "placeholder-element": "uynhga_placeholder-element",
  "push-down": "uynhga_push-down",
  "theme-bg-Aqua": "uynhga_theme-bg-Aqua",
  "theme-bg-BackgroundGray": "uynhga_theme-bg-BackgroundGray",
  "theme-bg-Berry": "uynhga_theme-bg-Berry",
  "theme-bg-Black": "uynhga_theme-bg-Black",
  "theme-bg-DarkAqua": "uynhga_theme-bg-DarkAqua",
  "theme-bg-DarkBerry": "uynhga_theme-bg-DarkBerry",
  "theme-bg-DarkGray": "uynhga_theme-bg-DarkGray",
  "theme-bg-DarkGreen": "uynhga_theme-bg-DarkGreen",
  "theme-bg-DarkMoss": "uynhga_theme-bg-DarkMoss",
  "theme-bg-DarkOrange": "uynhga_theme-bg-DarkOrange",
  "theme-bg-DarkRed": "uynhga_theme-bg-DarkRed",
  "theme-bg-DarkSmoke": "uynhga_theme-bg-DarkSmoke",
  "theme-bg-FadedAqua": "uynhga_theme-bg-FadedAqua",
  "theme-bg-FadedBerry": "uynhga_theme-bg-FadedBerry",
  "theme-bg-FadedGray": "uynhga_theme-bg-FadedGray",
  "theme-bg-FadedGreen": "uynhga_theme-bg-FadedGreen",
  "theme-bg-FadedMoss": "uynhga_theme-bg-FadedMoss",
  "theme-bg-FadedRed": "uynhga_theme-bg-FadedRed",
  "theme-bg-FadedSmoke": "uynhga_theme-bg-FadedSmoke",
  "theme-bg-Gray": "uynhga_theme-bg-Gray",
  "theme-bg-Green": "uynhga_theme-bg-Green",
  "theme-bg-HighlightMossModerate": "uynhga_theme-bg-HighlightMossModerate",
  "theme-bg-HighlightMossStrong": "uynhga_theme-bg-HighlightMossStrong",
  "theme-bg-HighlightMossSubtle": "uynhga_theme-bg-HighlightMossSubtle",
  "theme-bg-LightAqua": "uynhga_theme-bg-LightAqua",
  "theme-bg-LightBerry": "uynhga_theme-bg-LightBerry",
  "theme-bg-LightGray": "uynhga_theme-bg-LightGray",
  "theme-bg-LightGreen": "uynhga_theme-bg-LightGreen",
  "theme-bg-LightMoss": "uynhga_theme-bg-LightMoss",
  "theme-bg-LightRed": "uynhga_theme-bg-LightRed",
  "theme-bg-LightSmoke": "uynhga_theme-bg-LightSmoke",
  "theme-bg-Moss": "uynhga_theme-bg-Moss",
  "theme-bg-Orange": "uynhga_theme-bg-Orange",
  "theme-bg-Red": "uynhga_theme-bg-Red",
  "theme-bg-Smoke": "uynhga_theme-bg-Smoke",
  "theme-bg-White": "uynhga_theme-bg-White",
  "theme-bg-aqua": "uynhga_theme-bg-aqua",
  "theme-bg-backdrop": "uynhga_theme-bg-backdrop",
  "theme-bg-background-gray": "uynhga_theme-bg-background-gray",
  "theme-bg-berry": "uynhga_theme-bg-berry",
  "theme-bg-black": "uynhga_theme-bg-black",
  "theme-bg-dark-aqua": "uynhga_theme-bg-dark-aqua",
  "theme-bg-dark-berry": "uynhga_theme-bg-dark-berry",
  "theme-bg-dark-gray": "uynhga_theme-bg-dark-gray",
  "theme-bg-dark-green": "uynhga_theme-bg-dark-green",
  "theme-bg-dark-moss": "uynhga_theme-bg-dark-moss",
  "theme-bg-dark-orange": "uynhga_theme-bg-dark-orange",
  "theme-bg-dark-red": "uynhga_theme-bg-dark-red",
  "theme-bg-dark-smoke": "uynhga_theme-bg-dark-smoke",
  "theme-bg-faded-aqua": "uynhga_theme-bg-faded-aqua",
  "theme-bg-faded-berry": "uynhga_theme-bg-faded-berry",
  "theme-bg-faded-gray": "uynhga_theme-bg-faded-gray",
  "theme-bg-faded-green": "uynhga_theme-bg-faded-green",
  "theme-bg-faded-moss": "uynhga_theme-bg-faded-moss",
  "theme-bg-faded-red": "uynhga_theme-bg-faded-red",
  "theme-bg-faded-smoke": "uynhga_theme-bg-faded-smoke",
  "theme-bg-gray": "uynhga_theme-bg-gray",
  "theme-bg-green": "uynhga_theme-bg-green",
  "theme-bg-highlight-moss-moderate": "uynhga_theme-bg-highlight-moss-moderate",
  "theme-bg-highlight-moss-subtle": "uynhga_theme-bg-highlight-moss-subtle",
  "theme-bg-light-aqua": "uynhga_theme-bg-light-aqua",
  "theme-bg-light-berry": "uynhga_theme-bg-light-berry",
  "theme-bg-light-gray": "uynhga_theme-bg-light-gray",
  "theme-bg-light-green": "uynhga_theme-bg-light-green",
  "theme-bg-light-moss": "uynhga_theme-bg-light-moss",
  "theme-bg-light-red": "uynhga_theme-bg-light-red",
  "theme-bg-light-smoke": "uynhga_theme-bg-light-smoke",
  "theme-bg-moss": "uynhga_theme-bg-moss",
  "theme-bg-orange": "uynhga_theme-bg-orange",
  "theme-bg-red": "uynhga_theme-bg-red",
  "theme-bg-smoke": "uynhga_theme-bg-smoke",
  "theme-bg-standard": "uynhga_theme-bg-standard",
  "theme-bg-subtle": "uynhga_theme-bg-subtle",
  "theme-bg-text-Aqua": "uynhga_theme-bg-text-Aqua",
  "theme-bg-text-BackgroundGray": "uynhga_theme-bg-text-BackgroundGray",
  "theme-bg-text-Berry": "uynhga_theme-bg-text-Berry",
  "theme-bg-text-Black": "uynhga_theme-bg-text-Black",
  "theme-bg-text-DarkAqua": "uynhga_theme-bg-text-DarkAqua",
  "theme-bg-text-DarkBerry": "uynhga_theme-bg-text-DarkBerry",
  "theme-bg-text-DarkGray": "uynhga_theme-bg-text-DarkGray",
  "theme-bg-text-DarkGreen": "uynhga_theme-bg-text-DarkGreen",
  "theme-bg-text-DarkMoss": "uynhga_theme-bg-text-DarkMoss",
  "theme-bg-text-DarkOrange": "uynhga_theme-bg-text-DarkOrange",
  "theme-bg-text-DarkRed": "uynhga_theme-bg-text-DarkRed",
  "theme-bg-text-DarkSmoke": "uynhga_theme-bg-text-DarkSmoke",
  "theme-bg-text-FadedAqua": "uynhga_theme-bg-text-FadedAqua",
  "theme-bg-text-FadedBerry": "uynhga_theme-bg-text-FadedBerry",
  "theme-bg-text-FadedGray": "uynhga_theme-bg-text-FadedGray",
  "theme-bg-text-FadedGreen": "uynhga_theme-bg-text-FadedGreen",
  "theme-bg-text-FadedMoss": "uynhga_theme-bg-text-FadedMoss",
  "theme-bg-text-FadedRed": "uynhga_theme-bg-text-FadedRed",
  "theme-bg-text-FadedSmoke": "uynhga_theme-bg-text-FadedSmoke",
  "theme-bg-text-Gray": "uynhga_theme-bg-text-Gray",
  "theme-bg-text-Green": "uynhga_theme-bg-text-Green",
  "theme-bg-text-HighlightMossModerate": "uynhga_theme-bg-text-HighlightMossModerate",
  "theme-bg-text-HighlightMossStrong": "uynhga_theme-bg-text-HighlightMossStrong",
  "theme-bg-text-HighlightMossSubtle": "uynhga_theme-bg-text-HighlightMossSubtle",
  "theme-bg-text-LightAqua": "uynhga_theme-bg-text-LightAqua",
  "theme-bg-text-LightBerry": "uynhga_theme-bg-text-LightBerry",
  "theme-bg-text-LightGray": "uynhga_theme-bg-text-LightGray",
  "theme-bg-text-LightGreen": "uynhga_theme-bg-text-LightGreen",
  "theme-bg-text-LightMoss": "uynhga_theme-bg-text-LightMoss",
  "theme-bg-text-LightRed": "uynhga_theme-bg-text-LightRed",
  "theme-bg-text-LightSmoke": "uynhga_theme-bg-text-LightSmoke",
  "theme-bg-text-Moss": "uynhga_theme-bg-text-Moss",
  "theme-bg-text-Orange": "uynhga_theme-bg-text-Orange",
  "theme-bg-text-Red": "uynhga_theme-bg-text-Red",
  "theme-bg-text-Smoke": "uynhga_theme-bg-text-Smoke",
  "theme-bg-text-White": "uynhga_theme-bg-text-White",
  "theme-bg-white": "uynhga_theme-bg-white",
  "theme-color-Aqua": "uynhga_theme-color-Aqua",
  "theme-color-BackgroundGray": "uynhga_theme-color-BackgroundGray",
  "theme-color-Berry": "uynhga_theme-color-Berry",
  "theme-color-Black": "uynhga_theme-color-Black",
  "theme-color-DarkAqua": "uynhga_theme-color-DarkAqua",
  "theme-color-DarkBerry": "uynhga_theme-color-DarkBerry",
  "theme-color-DarkGray": "uynhga_theme-color-DarkGray",
  "theme-color-DarkGreen": "uynhga_theme-color-DarkGreen",
  "theme-color-DarkMoss": "uynhga_theme-color-DarkMoss",
  "theme-color-DarkOrange": "uynhga_theme-color-DarkOrange",
  "theme-color-DarkRed": "uynhga_theme-color-DarkRed",
  "theme-color-DarkSmoke": "uynhga_theme-color-DarkSmoke",
  "theme-color-FadedAqua": "uynhga_theme-color-FadedAqua",
  "theme-color-FadedBerry": "uynhga_theme-color-FadedBerry",
  "theme-color-FadedGray": "uynhga_theme-color-FadedGray",
  "theme-color-FadedGreen": "uynhga_theme-color-FadedGreen",
  "theme-color-FadedMoss": "uynhga_theme-color-FadedMoss",
  "theme-color-FadedRed": "uynhga_theme-color-FadedRed",
  "theme-color-FadedSmoke": "uynhga_theme-color-FadedSmoke",
  "theme-color-Gray": "uynhga_theme-color-Gray",
  "theme-color-Green": "uynhga_theme-color-Green",
  "theme-color-HighlightMossModerate": "uynhga_theme-color-HighlightMossModerate",
  "theme-color-HighlightMossStrong": "uynhga_theme-color-HighlightMossStrong",
  "theme-color-HighlightMossSubtle": "uynhga_theme-color-HighlightMossSubtle",
  "theme-color-LightAqua": "uynhga_theme-color-LightAqua",
  "theme-color-LightBerry": "uynhga_theme-color-LightBerry",
  "theme-color-LightGray": "uynhga_theme-color-LightGray",
  "theme-color-LightGreen": "uynhga_theme-color-LightGreen",
  "theme-color-LightMoss": "uynhga_theme-color-LightMoss",
  "theme-color-LightRed": "uynhga_theme-color-LightRed",
  "theme-color-LightSmoke": "uynhga_theme-color-LightSmoke",
  "theme-color-Moss": "uynhga_theme-color-Moss",
  "theme-color-Orange": "uynhga_theme-color-Orange",
  "theme-color-Red": "uynhga_theme-color-Red",
  "theme-color-Smoke": "uynhga_theme-color-Smoke",
  "theme-color-White": "uynhga_theme-color-White",
  "theme-color-aqua": "uynhga_theme-color-aqua",
  "theme-color-background-gray": "uynhga_theme-color-background-gray",
  "theme-color-berry": "uynhga_theme-color-berry",
  "theme-color-black": "uynhga_theme-color-black",
  "theme-color-dark-aqua": "uynhga_theme-color-dark-aqua",
  "theme-color-dark-berry": "uynhga_theme-color-dark-berry",
  "theme-color-dark-gray": "uynhga_theme-color-dark-gray",
  "theme-color-dark-green": "uynhga_theme-color-dark-green",
  "theme-color-dark-moss": "uynhga_theme-color-dark-moss",
  "theme-color-dark-orange": "uynhga_theme-color-dark-orange",
  "theme-color-dark-red": "uynhga_theme-color-dark-red",
  "theme-color-dark-smoke": "uynhga_theme-color-dark-smoke",
  "theme-color-faded-aqua": "uynhga_theme-color-faded-aqua",
  "theme-color-faded-berry": "uynhga_theme-color-faded-berry",
  "theme-color-faded-gray": "uynhga_theme-color-faded-gray",
  "theme-color-faded-green": "uynhga_theme-color-faded-green",
  "theme-color-faded-moss": "uynhga_theme-color-faded-moss",
  "theme-color-faded-red": "uynhga_theme-color-faded-red",
  "theme-color-faded-smoke": "uynhga_theme-color-faded-smoke",
  "theme-color-gray": "uynhga_theme-color-gray",
  "theme-color-green": "uynhga_theme-color-green",
  "theme-color-highlight-moss-moderate": "uynhga_theme-color-highlight-moss-moderate",
  "theme-color-highlight-moss-subtle": "uynhga_theme-color-highlight-moss-subtle",
  "theme-color-light-aqua": "uynhga_theme-color-light-aqua",
  "theme-color-light-berry": "uynhga_theme-color-light-berry",
  "theme-color-light-gray": "uynhga_theme-color-light-gray",
  "theme-color-light-green": "uynhga_theme-color-light-green",
  "theme-color-light-moss": "uynhga_theme-color-light-moss",
  "theme-color-light-red": "uynhga_theme-color-light-red",
  "theme-color-light-smoke": "uynhga_theme-color-light-smoke",
  "theme-color-moss": "uynhga_theme-color-moss",
  "theme-color-orange": "uynhga_theme-color-orange",
  "theme-color-red": "uynhga_theme-color-red",
  "theme-color-smoke": "uynhga_theme-color-smoke",
  "theme-color-text-Aqua": "uynhga_theme-color-text-Aqua",
  "theme-color-text-BackgroundGray": "uynhga_theme-color-text-BackgroundGray",
  "theme-color-text-Berry": "uynhga_theme-color-text-Berry",
  "theme-color-text-Black": "uynhga_theme-color-text-Black",
  "theme-color-text-DarkAqua": "uynhga_theme-color-text-DarkAqua",
  "theme-color-text-DarkBerry": "uynhga_theme-color-text-DarkBerry",
  "theme-color-text-DarkGray": "uynhga_theme-color-text-DarkGray",
  "theme-color-text-DarkGreen": "uynhga_theme-color-text-DarkGreen",
  "theme-color-text-DarkMoss": "uynhga_theme-color-text-DarkMoss",
  "theme-color-text-DarkOrange": "uynhga_theme-color-text-DarkOrange",
  "theme-color-text-DarkRed": "uynhga_theme-color-text-DarkRed",
  "theme-color-text-DarkSmoke": "uynhga_theme-color-text-DarkSmoke",
  "theme-color-text-FadedAqua": "uynhga_theme-color-text-FadedAqua",
  "theme-color-text-FadedBerry": "uynhga_theme-color-text-FadedBerry",
  "theme-color-text-FadedGray": "uynhga_theme-color-text-FadedGray",
  "theme-color-text-FadedGreen": "uynhga_theme-color-text-FadedGreen",
  "theme-color-text-FadedMoss": "uynhga_theme-color-text-FadedMoss",
  "theme-color-text-FadedRed": "uynhga_theme-color-text-FadedRed",
  "theme-color-text-FadedSmoke": "uynhga_theme-color-text-FadedSmoke",
  "theme-color-text-Gray": "uynhga_theme-color-text-Gray",
  "theme-color-text-Green": "uynhga_theme-color-text-Green",
  "theme-color-text-HighlightMossModerate": "uynhga_theme-color-text-HighlightMossModerate",
  "theme-color-text-HighlightMossStrong": "uynhga_theme-color-text-HighlightMossStrong",
  "theme-color-text-HighlightMossSubtle": "uynhga_theme-color-text-HighlightMossSubtle",
  "theme-color-text-LightAqua": "uynhga_theme-color-text-LightAqua",
  "theme-color-text-LightBerry": "uynhga_theme-color-text-LightBerry",
  "theme-color-text-LightGray": "uynhga_theme-color-text-LightGray",
  "theme-color-text-LightGreen": "uynhga_theme-color-text-LightGreen",
  "theme-color-text-LightMoss": "uynhga_theme-color-text-LightMoss",
  "theme-color-text-LightRed": "uynhga_theme-color-text-LightRed",
  "theme-color-text-LightSmoke": "uynhga_theme-color-text-LightSmoke",
  "theme-color-text-Moss": "uynhga_theme-color-text-Moss",
  "theme-color-text-Orange": "uynhga_theme-color-text-Orange",
  "theme-color-text-Red": "uynhga_theme-color-text-Red",
  "theme-color-text-Smoke": "uynhga_theme-color-text-Smoke",
  "theme-color-text-White": "uynhga_theme-color-text-White",
  "theme-color-white": "uynhga_theme-color-white",
});
